import { ReactElement } from "react";

import { SearchHighlight } from "./search-highlight";

interface IEntityPropertiesPlaceholderValueProps {
  label: string;
  value: string;
  isOpen: boolean;
}

export const EntityPropertyPlaceholderValue = ({
  label,
  value,
  isOpen,
}: IEntityPropertiesPlaceholderValueProps): ReactElement => {
  return (
    <div className="entityProperty entityProperty__sub">
      <div className="entityProperty__key">
        <SearchHighlight isKey text={label} />
      </div>
      <div>
        {value}
        <span
          className={`entityProperty__toggle-sign entityProperty__toggle-sign--${isOpen ? "collapse" : "expand"}`}
          aria-hidden="true"
        >
          {isOpen ? "−" : "+"}
        </span>
      </div>
    </div>
  );
};
